module.exports = __webpack_public_path__ + "img/bottonImg.d5efa31f.png";